module.exports = __webpack_public_path__ + "img/9788937432057.4711e38d.jpg";